import { Component } from '@angular/core';

@Component({
  selector: 'app-sinclair-prosser',
  templateUrl: './sinclair-prosser.component.html',
  styleUrls: ['./sinclair-prosser.component.scss']
})
export class SinclairProsserComponent {

}
